import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.09525 1.51691C5.83335 2.64807 3.4856 5.62976 3.4856 9.16076C3.4856 12.1606 5.18511 14.769 7.69462 16.1762V19.5276C7.69462 20.3847 8.38951 21.0796 9.2467 21.0796H10.4289C10.5396 21.8556 11.2068 22.4521 12.0133 22.4521C12.8199 22.4521 13.4871 21.8556 13.5978 21.0796H14.7535C15.6107 21.0796 16.3056 20.3847 16.3056 19.5276V16.1772C18.8161 14.7703 20.5164 12.1613 20.5164 9.16076C20.5164 5.59772 18.1259 2.594 14.8177 1.48658C13.9408 1.17207 12.9906 1 11.9981 1C10.9741 1 9.99512 1.18315 9.09525 1.51691ZM8.89379 10.3413C9.07923 10.1239 9.40578 10.098 9.62316 10.2835L12.011 12.3205L14.3993 10.2834C14.6167 10.098 14.9433 10.1239 15.1287 10.3413C15.3141 10.5587 15.2882 10.8853 15.0708 11.0707L12.5283 13.2392V15.3882H11.4936V13.2392L8.9516 11.0706C8.73423 10.8852 8.70834 10.5586 8.89379 10.3413ZM8.72934 17.6728V16.4229H15.2709V17.6728H8.72934ZM8.72934 18.7075V19.5276C8.72934 19.8133 8.96097 20.0449 9.2467 20.0449H14.7535C15.0393 20.0449 15.2709 19.8133 15.2709 19.5276V18.7075H8.72934Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'insight-filled');
export default IconComponent;
